module.exports = __webpack_public_path__ + "static/kran02_768-e6b208aeca9319e38b8cae0aae0631ee.jpg";